export default function(item) {
  return JSON.stringify(item, null, "\t");
}
